<div class="error-container">
  <aur-notice severity="error">
    {{ 'ARC_SESSION_EXPIRED' | translate }}
  </aur-notice>
</div>
